// src/services/feedbackExportService.js
import api from './api';

const feedbackExportService = {
  exportNewFeedbackToExcel: () => {
    return api.get('/admin/feedback/export/new', {
      responseType: 'blob' // важно за файловия отговор
    });
  },

  downloadExportedFile: (filename) => {
    return api.get(`/admin/feedback/export/download/${filename}`, {
      responseType: 'blob'
    });
  },

  // Допълнителен метод за експорт с филтри
  exportFilteredFeedbackToExcel: (filters) => {
    return api.get('/admin/feedback/export/filtered', {
      params: filters,
      responseType: 'blob'
    });
  }
};

export default feedbackExportService;